import { useMandatoryProcessTasks } from 'generated/resources/datatable.graphql'
import { ProcessesProcessCategoryEnum, SelectorAccessFragment } from 'generated/resources/graphql'

import { assigneeFilter } from './assigneeFilter'
import { ownerFilter } from './ownerFilter'
import { statusFilter } from './statusFilter'
import { stepNameFilter } from './stepNameFilter'
import { taskNameFilter } from './taskNameFilter'

export const filters = (
  category: ProcessesProcessCategoryEnum,
  source: ReturnType<typeof useMandatoryProcessTasks>,
  accesses: SelectorAccessFragment[]
) => [
  assigneeFilter(source, accesses),
  ownerFilter(category, source, accesses),
  taskNameFilter(source),
  statusFilter(source),
  stepNameFilter(source),
]
